import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'

import NotesTeamItem from './NotesTeamItem'
import JobModuleBase from '../JobModuleBase'
import ModulesUtils from 'infra/ModulesUtils'
import AllNotesScreen from './AllNotesScreen'

import '../styles.css'

class NotesTeamModule extends JobModuleBase {

  static propTypes = {
    dateStr: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    firebase.database()
      .ref(this.getDayNotesDbPath())
      .on('value', this.onUpdate)
  }

  componentWillUnmount() {
    firebase.database()
      .ref(this.getDayNotesDbPath())
      .off('value', this.onUpdate)
  }

  getDayNotesDbPath = () => {
    return `${this.getExtendedModulesDbPath()}/${this.props.dateStr}`
  }

  onUpdate = snapshot => {
    const value = snapshot && snapshot.val()
    const notesTeam = value || {}
    this.setState({ notesTeam })
  }

  renderNotes() {
    const views = []
    if (!this.state.notesTeam || !this.state.notesTeam.list) {
      return null
    }
    const list = this.state.notesTeam.list
    for (const key in list) {
      if (list.hasOwnProperty(key)) {
        views.push(<NotesTeamItem
          key={key}
          name={ModulesUtils.getMemberName(this.props.teamMembers, key)}
          note={list[key].value}
        />)
      }
    }
    return views
  }

  render() {
    return (
      <div
        style={{ marginTop: 20, marginBottom: 30 }}
        className="vertical-container">
        { this.renderNotes() }
        <AllNotesScreen
          open={this.props.openShowAllNotesScreen}
          jobName={this.props.jobInfo.modules.displayName.value}
          notesListDbPath={this.getExtendedModulesDbPath()}
          onRequestClose={this.props.onRequestClose} />
      </div>
    )
  }

}

export default connect(state => ({ teamMembers: state.firebase.team.members.value }))(NotesTeamModule)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/notes/NotesTeamModule.js